var _desc, _defs, _rect, _text, _text2, _path, _path2, _path3, _text3, _text4, _path4, _text5, _path5, _text6, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _text7, _path12, _text8, _path13, _path14, _path15, _text9, _text0, _path16, _path17, _path18, _text1, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _text10, _text11, _text12, _text13, _text14, _text15, _text16, _text17, _text18, _text19, _text20, _text21, _text22;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEventSpacePlan(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1135,
    height: 852,
    viewBox: "0 0 1135 852",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "FMX event space plan") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Minimal FMX setup plan with R8 ramp, 2.65 meter ramp height, 21 meter flight gap, landing, bottom meter segments, total length, 10 meter free height, and 10 meter depth.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "arrow",
    viewBox: "0 0 10 10",
    refX: 5,
    refY: 5,
    markerWidth: 7,
    markerHeight: 7,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 10 5 L 0 10 z",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("style", null, "\n      .bg { fill: #1c1c22; }\n      .line { fill: none; stroke: #ffffff; stroke-width: 3; stroke-linecap: round; stroke-linejoin: round; }\n      .thin { fill: none; stroke: #bfc0c4; stroke-width: 1.7; stroke-linecap: round; stroke-linejoin: round; }\n      .dim { fill: none; stroke: #ffffff; stroke-width: 2.2; marker-start: url(#arrow); marker-end: url(#arrow); }\n      .tick { stroke: #ffffff; stroke-width: 2; }\n      .accent { fill: #00ff99; font-family: 'JetBrains Mono', 'Courier New', monospace; font-size: 44px; font-weight: 700; letter-spacing: 0; }\n      .text { fill: #ffffff; font-family: 'JetBrains Mono', 'Courier New', monospace; font-size: 23px; font-weight: 700; letter-spacing: 0; }\n      .small { fill: #ffffff; font-family: 'JetBrains Mono', 'Courier New', monospace; font-size: 23px; font-weight: 700; letter-spacing: 0; }\n      .tiny { fill: #ffffff; font-family: 'JetBrains Mono', 'Courier New', monospace; font-size: 23px; font-weight: 700; letter-spacing: 0; }\n      .event-description { fill: #c7c8cc; font-family: 'JetBrains Mono', 'Courier New', monospace; font-size: 26px; font-weight: 700; letter-spacing: 0; }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "bg",
    width: 1135,
    height: 852,
    rx: 8
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 74,
    className: "accent"
  }, "EVENT SPACE")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 118,
    className: "event-description"
  }, "Minimum clear layout for ramp, landing, and braking area.")), /*#__PURE__*/React.createElement("path", {
    className: "line",
    style: {
      strokeLinecap: "butt"
    },
    d: "M 385 492 A 96 96 0 0 0 456.4 460.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "line",
    style: {
      strokeLinecap: "butt"
    },
    d: "M 385 492 L 457 492 L 456.4 460.2"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "thin",
    d: "M 406 490 L 456.4 469"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "thin",
    d: "M 430 481 L 456.4 460.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "thin",
    d: "M 431 480 L 431 492"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 413,
    y: 548,
    className: "text"
  }, "RAMP")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 409,
    y: 456,
    className: "small"
  }, "R8")), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "dim",
    d: "M 476 460.2 L 476 492"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 492,
    y: 481,
    className: "small"
  }, "2.65 M")), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "thin",
    d: "M 456.4 460.2 C 536 410, 630 410, 709 444",
    strokeDasharray: "8 11"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 516,
    y: 402,
    className: "small"
  }, "21 M FLIGHT GAP")), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "line",
    d: "M 661 492 L 685 444 L 709 444 L 829 492 L 661 492"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "line",
    d: "M 685 444 L 685 492"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "thin",
    d: "M 709 444 L 709 492"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "thin",
    d: "M 673 468 L 685 444"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "thin",
    d: "M 735 492 L 745 458"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "thin",
    d: "M 759 492 L 777 471"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "thin",
    d: "M 789 492 L 809 484"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "thin",
    d: "M 805 492 L 829 492"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 690,
    y: 548,
    className: "text"
  }, "LANDING")), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "dim",
    d: "M 642 444 L 642 492"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 475,
    className: "small"
  }, "4 M")), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "dim",
    d: "M 1070 372 L 1070 492"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "tick",
    d: "M 1043 372 L 1097 372"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "tick",
    d: "M 1043 492 L 1097 492"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 888,
    y: 420,
    className: "text"
  }, "MIN. 10 M")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 900,
    y: 450,
    className: "small"
  }, "FREE HEIGHT")), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "dim",
    d: "M 905 625 L 990 540"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "tick",
    d: "M 898 618 L 912 632"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "tick",
    d: "M 983 533 L 997 547"
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 888,
    y: 647,
    className: "small"
  }, "MIN. DEPTH 10 M")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "tick",
    x1: 85,
    y1: 710,
    x2: 1045,
    y2: 710
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "tick",
    x1: 85,
    y1: 694,
    x2: 85,
    y2: 728
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "tick",
    x1: 385,
    y1: 694,
    x2: 385,
    y2: 728
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "tick",
    x1: 457,
    y1: 694,
    x2: 457,
    y2: 728
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "tick",
    x1: 685,
    y1: 694,
    x2: 685,
    y2: 728
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "tick",
    x1: 709,
    y1: 694,
    x2: 709,
    y2: 728
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "tick",
    x1: 829,
    y1: 694,
    x2: 829,
    y2: 728
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "tick",
    x1: 1045,
    y1: 694,
    x2: 1045,
    y2: 728
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 218,
    y: 682,
    className: "tiny"
  }, "1.")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 418,
    y: 682,
    className: "tiny"
  }, "2.")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 565,
    y: 682,
    className: "tiny"
  }, "3.")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 691,
    y: 682,
    className: "tiny"
  }, "4.")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 763,
    y: 682,
    className: "tiny"
  }, "5.")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 936,
    y: 682,
    className: "tiny"
  }, "6.")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 205,
    y: 755,
    className: "text"
  }, "25 M")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 398,
    y: 755,
    className: "text"
  }, "6 M")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 554,
    y: 755,
    className: "text"
  }, "19 M")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 688,
    y: 755,
    className: "text"
  }, "2 M")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 752,
    y: 755,
    className: "text"
  }, "10 M")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 928,
    y: 755,
    className: "text"
  }, "18 M")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 812,
    className: "accent"
  }, "TOTAL LENGTH: 80 M MIN.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventSpacePlan);
export default __webpack_public_path__ + "static/media/event-space-plan.0a24c6479c0d4dde1624570c7c4f2e98.svg";
export { ForwardRef as ReactComponent };